import { useContext, useRef } from "react"
import CommonFunctionsContext from "../../../../common/CommonFunctionsProvider"
import { ToDoListAdminContext } from "../ToDoListAdmin"
import TitleBarComponent from "./TitleBarComponent"

export default function ToDoListItemsLineItem({ group, list, children, onRemove, onEdit }) {
    const { showConfirm, showError } = useContext(CommonFunctionsContext)
    const { cloneToDoListItem, cloneToDoListItemArray } = useContext(ToDoListAdminContext)
    const CloneNameRef = useRef()
    const CloneBulkRef = useRef()

    const _handleClone = async (e) => {
        if (e) {
            e.stopPropagation()
        }
        showConfirm({
            layout: 'beeeg',
            onCancel: () => { },
            onConfirm: (a) => {
                if (CloneBulkRef.current.value && CloneBulkRef.current.value !== "") {
                    const split = CloneBulkRef.current.value.split("\n")
                        .map(itemName => itemName.trim())
                    cloneToDoListItemArray(
                        group.id,
                        list.resource.id,
                        split
                    )
                        .then(res => { return true })
                        .catch(err => showError(err))
                }
                else {
                    if (!CloneNameRef.current.value || CloneNameRef.current.value === '') {
                        CloneNameRef.current.placeholder = 'Please enter a name to clone to'
                        CloneNameRef.current.style = 'border: solid red 2px'
                        return false
                    }
                    cloneToDoListItem(
                        group.id,
                        list.resource.id,
                        CloneNameRef.current.value
                    )
                        .then(res => { return true })
                        .catch(err => showError(err))
                }
            }
            ,
            title: () => { },
            heading: "Clone : New Name",
            children: <div>
                <p>Please enter a name for the new item</p>
                <input
                    ref={CloneNameRef}
                    className='form-control' placeholder='New name' />
                <b>Or</b>
                <textarea ref={CloneBulkRef} className='form-control' rows={10} placeholder='Enter a list of items to clone in bulk separated by a new line for each item'>

                </textarea>
            </div>,
            // type: () => { },
            options: {
                cancel: 'Cancel',
                confirm: 'Clone'
            }
        })
    }


    return (<>
        <div className='lists-container'>
            <TitleBarComponent
                cloneable={{
                    action: _handleClone
                }}
                reference='FacilityToDoListNewListItemItem'
                onEdit={onEdit}
                onRemove={onRemove}
                container={list.resource.list}
                title={list.resource.list}
            />
            {children}
        </div>
    </>)
}
